import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import { domContentLoadEvent } from '../common/domContentLoadEvent';
let modalSwiperInstance;

function initializeGalleryArticle(galleryElement) {
    const swiperPagination = galleryElement.querySelector('.swiper-pagination');
    const swiperInstance = new Swiper(galleryElement.querySelector('.swiper'), {
        modules: [Pagination, Navigation, Autoplay],
        slidesPerView: 1,
        loop: false,
        pagination: {
            el: swiperPagination,
            clickable: true,
        },
        navigation: {
            nextEl: '.gallery-article .swiper-button-next',
            prevEl: '.gallery-article .swiper-button-prev',
        },
        breakpoints: {
            1024: {
                slidesPerView: 5,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
            },
        },
        on: {
            init: function () {
                this.slides.forEach((slide, index) => {
                    slide.addEventListener('click', () => openModal(index));
                });
            },
        },
    });
}

function initializeGalleryModal(galleryElement) {
    const swiperPagination = galleryElement.querySelector('.swiper-pagination-gallery');
    modalSwiperInstance = new Swiper(galleryElement.querySelector('.modal-gallery .swiper'), {
        modules: [Pagination, Navigation],
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: swiperPagination,
            clickable: true,
        },
        navigation: {
            nextEl: '.modal-gallery .swiper-button-next-gallery',
            prevEl: '.modal-gallery .swiper-button-prev-gallery',
        },
    });
}

function toggleModalClasses(element, classes) {
    classes.forEach((cls) => element.classList.toggle(cls));
}

function openModal(index) {
    const modal = document.querySelector('.modal-gallery');
    toggleModalClasses(modal, ['invisible', '-z-modal', 'opacity-0', 'z-modal', 'opacity-1']);

    const modalContent = modal.querySelector('.modal-gallery-content');
    toggleModalClasses(modalContent, ['-z-modal-content', 'z-modal-content']);

    const modalClose = modal.querySelector('.close-modal');
    modalClose.addEventListener('click', closeModal);

    if (modalSwiperInstance) {
        modalSwiperInstance.slideTo(index);
    }
}

function closeModal() {
    const modal = document.querySelector('.modal-gallery');
    toggleModalClasses(modal, ['invisible', '-z-modal', 'opacity-0', 'z-modal-content']);
}

function initializeAllGalleries() {
    document.querySelectorAll('.gallery-article').forEach(initializeGalleryArticle);
    document.querySelectorAll('.modal-gallery').forEach(initializeGalleryModal);
}

domContentLoadEvent(initializeAllGalleries);
